<template>
  <div class="container">
    <div class="header-search">
      <div class="search-box">
        <img class="icon" src="@/assets/search_icon@3x.png" />
        <input placeholder="搜索商品名称/类别" @keyup.enter="onSearchConfirm()" v-model="keyword" />
      </div>
    </div>
    <div class="label-container">
      <div class="title" v-if="showHistoryKeywords">历史记录</div>
      <div class="content" v-if="showHistoryKeywords">
        <div class="blank" v-if="historyKeywords.length === 0">暂无搜索历史</div>
        <router-link
          class="label"
          :key="index"
          :to="{ name: 'searchResult', query: { keyword: item.content } }"
          v-for="(item, index) in historyKeywords"
        >
          {{ item.content }}
        </router-link>
      </div>
      <div class="title">热门搜索</div>
      <div class="content">
        <div class="blank" v-if="popularKeywords.length === 0">暂无热门搜索</div>
        <router-link
          class="label"
          :key="index"
          :to="{ name: 'searchResult', query: { keyword: item.content } }"
          v-for="(item, index) in popularKeywords"
        >
          {{ item.content }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped src="./Search.sass"></style>

<script>
import product from '@/api/product';

export default {
  data: () => ({
    keyword: '',

    // 历史搜索关键词
    historyKeywords: [],
    showHistoryKeywords: false,
    // 热门搜索关键词
    popularKeywords: [],
  }),

  mounted() {
    this.fetchHistorySearchKeywords();
    this.fetchPopularSearchKeywords();
  },

  methods: {
    onSearchConfirm() {
      if (this.keyword === '') {
        return;
      }

      this.$router.push({
        name: 'searchResult',
        query: {
          keyword: this.keyword,
        },
      });
    },

    /**
     * 获取用户搜索历史关键词
     */
    fetchHistorySearchKeywords() {
      if (!this.token) {
        return;
      }
      this.showHistoryKeywords = true;
      product.fetchHistorySearchKeywords({}, res => {
        if (res.code > 0) {
          return;
        }

        this.setData({
          historyKeywords: res.data,
        });
      });
    },

    fetchPopularSearchKeywords() {
      product.fetchPopularSearchKeywords({}).then(res => {
        const {
          data: { code, data },
        } = res;

        if (code > 0) {
          return;
        }

        this.popularKeywords = data;
      });
    },
  },
};
</script>
